import { Fragment, useMemo } from 'react';
import type React from 'react';

import { CardList } from '@change-corgi/design-system-legacy/layout';

import { PetitionCardViewTracker } from '../../../../shared/components/viewTracking';
import type { SuggestedPetitionSourceLocation } from '../../../../shared/types';
import type { NewlyCreatedPetition } from '../../types';

import { NewlyCreatedPetitionCard } from './components/NewlyCreatedPetitionCard';

type Props = Readonly<{
	petitions: ReadonlyArray<{ node: NewlyCreatedPetition }>;
	parentPetitionId?: string;
	sourceLocation: SuggestedPetitionSourceLocation;
}>;

export const NewlyCreatedPetitionsList: React.FC<Props> = ({ petitions, parentPetitionId, sourceLocation }) => {
	const displayCount = 4;
	const displayedPetitions = useMemo(() => petitions.slice(0, displayCount), [petitions, displayCount]);

	return (
		<CardList
			data-qa="newly-created-petitions"
			itemsPerRow={[1, 2, 3, 4]}
			itemWidth="dynamic"
			itemSpacing={['small', 'default']}
			maxListWidth={[400, 'none']}
		>
			{displayedPetitions.map((petition, index) => (
				<Fragment key={petition.node.id}>
					<PetitionCardViewTracker
						petitionId={petition.node.id}
						petitionStatus="open"
						parentPetitionId={parentPetitionId}
						gridPosition={index + 1}
						algorithm="newly_created"
						strategy="newly_created"
					/>
					<NewlyCreatedPetitionCard
						petition={petition}
						parentPetitionId={parentPetitionId}
						gridPosition={index + 1}
						sourceLocation={sourceLocation}
					/>
				</Fragment>
			))}
		</CardList>
	);
};
